import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import {
  GIFT_CATEGORY_DETAIL_QUERY,
  GIFT_CATEGORY_LIST_QUERY,
} from "../../Queries";
import Presenter from "./Presenter";

export default withRouter(({ history, match, location }) => {
  const { data: detail } = useQuery(GIFT_CATEGORY_DETAIL_QUERY, {
    variables: { id: match.params.id },
  });

  const { data: giftCategories } = useQuery(GIFT_CATEGORY_LIST_QUERY, {
    variables: {
      giftConfig: match.params.config,
      parentId: "null",
    },
  });

  if (
    detail &&
    detail.AdminGiftCategoryDetail &&
    giftCategories &&
    giftCategories.AdminGiftCategoryList
  ) {
    const {
      AdminGiftCategoryDetail: {
        id,
        giftConfig,
        commonStatus,
        name,
        childrenCount,
      },
    } = detail;
    return (
      <Presenter
        history={history}
        match={match}
        location={location}
        id={id}
        giftConfig={giftConfig}
        commonStatus={commonStatus}
        name={name}
        childrenCount={childrenCount}
        giftCategories={giftCategories}
      ></Presenter>
    );
  } else {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  }
});
